import { render, staticRenderFns } from "./RoundedBox.vue?vue&type=template&id=0a1fdc6b&scoped=true&"
import script from "./RoundedBox.vue?vue&type=script&lang=js&"
export * from "./RoundedBox.vue?vue&type=script&lang=js&"
import style0 from "./RoundedBox.vue?vue&type=style&index=0&id=0a1fdc6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1fdc6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSheet,VSkeletonLoader})
